import { Text } from "@src/appV2/redesign/system/ui-components";

interface EmptyStateTextProps {
  readonly children: string;
}

/**
 * Styled text component for empty state messages.
 * Used consistently across ShiftDetails cards to indicate missing data.
 */
export function EmptyStateText({ children }: EmptyStateTextProps) {
  return (
    <Text
      variant="body2"
      sx={(theme) => ({ color: theme.palette.text.secondary, fontStyle: "italic" })}
    >
      {children}
    </Text>
  );
}
